import {
  MDBBadge,
  MDBBtn,
  MDBCol,
  MDBIcon,
  MDBInputGroup,
  MDBRipple,
  MDBRow,
  MDBSideNav,
  MDBSideNavCollapse,
  MDBSideNavItem,
  MDBSideNavLink, MDBSideNavMenu,
  MDBTypography
} from "mdb-react-ui-kit";

import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ClearDataButton from "../ClearDataButton";
import { CartContext } from "./context/CartProvider";
import { CategoryContext } from "./context/CategoryContext";
import { DomainContext } from "./context/DomainProvider";
import { GeographyContext } from "./context/GeographyProvider";
import { MiscContext } from "./context/MiscProvider";
import { NavbarContext } from "./context/NavProvider";
import { UserProfileContext } from "./context/UserProfileProvider";
import { fetchCompanyMap, fetchDocumentMap, fetchIPAddress, getDomainsAndCategories } from "./utils/Common";

export default function Sidenav({ containerRef }) {

  const [domainCollapseState, setDomainCollapseState] = useState({});
  const [mode, setMode] = useState('side');
  const [backdrop, setBackdrop] = useState(false);
  const [basicCollapse1, setBasicCollapse1] = useState(false);
  const [collapseApps, setCollapseApps] = useState(false);
  
  
  const [collapseStatistics, setCollapseStatistics] = useState(false);
  const [collapseDocuments, setCollapseDocuments] = useState(false);
  const [collapseRm, setCollapseRm] = useState(false);
  const {host,setReceipts, setDocumentsMap, companiesMap, setCompaniesMap, isDocumentsFetched, setIsDocumentsFetched, setIsCompaniesFetched  } = useContext(MiscContext);
  const {selectDomains,setSelectDomains,setGroupedDomainsByDomain,setDomainImages,domainId,domainData,setDomainId,setFirmId,firmId} = useContext(DomainContext);
  const {setGroupedCategoriesByDomain,setCategoryImages,selectCategories,setSelectCategories} = useContext(CategoryContext);

  const {ipAddress,setIPAddress,location,setCountry} = useContext(GeographyContext);
  const {tokenLoaded} = useContext(UserProfileContext)
  const {  avatar, setBasicOpen, basicOpen, business,  setBusiness,isPricing,permissions } = useContext(NavbarContext);
  const { cartCount,orders, ordersCount, setOrdersCount} = useContext(CartContext);
const {setIsLoginRequired} =useContext(UserProfileContext);
  const navigate = useNavigate();
  const [compCollapse1, setCompCollapse1] = useState(false);
  const innerWidth = useRef(null);
  const [collapseBills, setCollapseBills] = useState("Bills");
  const [collapseInvoices, setCollapseInvoices] = useState("Invoices");
  const [collapseReceipts, setCollapseReceipts] = useState("Receipts");
  const [collapsePictures, setCollapsePictures] = useState("Pictures");
  const [collapseTitles, setCollapseTitles] = useState("Titles");
  const [collapseOther, setCollapseOther] = useState("Other");
  const [collapseCreate, setCollapseCreate] = useState("Create");
  const [collapseProcessed, setCollapseProcessed] = useState("Processed");
  const [collapseUnprocessed, setCollapseUnprocessed] = useState("UnProcessed");
  const sortedCompanies = Array.isArray(companiesMap) ? [...companiesMap].sort((a, b) => a.name.localeCompare(b.name)) : [];
  const [dummy, setDummy] = useState(false);

  const didFetchRef = useRef(false);

  const [openDomainIndex, setOpenDomainIndex] = useState(null);

  const toggleDomainCollapse = (index) => {
    setOpenDomainIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  

  useEffect(() => {
    
    if (selectDomains?.length === 0) {
       fetchIPAddress(setIPAddress);
        getDomainsAndCategories(domainId,location,ipAddress,tokenLoaded,setBusiness,setCountry,setSelectCategories,setSelectDomains,setGroupedCategoriesByDomain,setCategoryImages,setGroupedDomainsByDomain,setDomainImages,setDomainId,setFirmId);
       
    }
}, []);

  const toggleCollapseCreate = (value) => {

    value !== collapseCreate ? setCollapseCreate(value) : setCollapseCreate('');
    setCollapseProcessed(false);
    setCollapseUnprocessed(false);
    setCollapseCreate(value === collapseCreate ? '' : value);
  };

  const toggleCollapseProcessed = (value) => {

    value !== collapseProcessed ? setCollapseProcessed(value) : setCollapseProcessed('');
    setCollapseProcessed(value === collapseProcessed ? '' : value);

  };

  const toggleCollapseUnProcessed = (value) => {
    value !== collapseUnprocessed ? setCollapseUnprocessed(value) : setCollapseUnprocessed('');

    setCollapseUnprocessed(value === collapseUnprocessed ? '' : value);
  };


  const processedRef = useRef(null);
  const unprocessedRef = useRef(null);

  useEffect(() => {
    if (processedRef.current) {
      setCollapseProcessed(processedRef.current.offsetHeight > 0);
    }
    if (unprocessedRef.current) {
      setCollapseUnprocessed(unprocessedRef.current.offsetHeight > 0);
    }
  }, [basicOpen]);
  const toggleCollapseReceipts = (value) => {

    value !== collapseReceipts ? setCollapseReceipts(value) : setCollapseReceipts('');
    setCollapseBills(false);
    setCollapseInvoices(false);
    setCollapseOther(false);
    setCollapseUnprocessed(false);
    setCollapseProcessed(false);
    setCollapseCreate(false);
    setCollapseReceipts(value === collapseReceipts ? '' : value);

  };

  const toggleCollapseTitles = (value) => {

    value !== collapseTitles ? setCollapseTitles(value) : setCollapseTitles('');
    setCollapseBills(false);
    setCollapseInvoices(false);
    setCollapsePictures(false);
    setCollapseOther(false);
    setCollapseReceipts(false);
    setCollapseUnprocessed(false);
    setCollapseProcessed(false);

    setCollapseCreate(false);
    setCollapseTitles(value === collapseTitles ? '' : value);

  };

  const toggleCollapsePictures = (value) => {

    value !== collapsePictures ? setCollapsePictures(value) : setCollapsePictures('');
    setCollapseBills(false);
    setCollapseInvoices(false);
    setCollapseOther(false);
    setCollapseReceipts(false);
    setCollapseUnprocessed(false);
    setCollapseProcessed(false);
    setCollapseCreate(false);
    setCollapseTitles(false);
    setCollapsePictures(value === collapsePictures ? '' : value);

  };




  const toggleCollapseBills = (value) => {

    value !== collapseBills ? setCollapseBills(value) : setCollapseBills('');
    setCollapseReceipts(false);
    setCollapseInvoices(false);
    setCollapseOther(false);
    setCollapseUnprocessed(false);
    setCollapseProcessed(false);
    setCollapseCreate(false);


  };
  const toggleCollapseInvoices = (value) => {

    value !== collapseInvoices ? setCollapseInvoices(value) : setCollapseInvoices('');
    setCollapseReceipts(false);
    setCollapseBills(false);
    setCollapseOther(false);
    setCollapseUnprocessed(false);
    setCollapseProcessed(false);
    setCollapseCreate(false);

  };
  const toggleCollapseOther = (value) => {

    value !== collapseOther ? setCollapseOther(value) : setCollapseOther('');
    setCollapseReceipts(false);
    setCollapseInvoices(false);
    setCollapseBills(false);
    setCollapseUnprocessed(false);
    setCollapseProcessed(false);
    setCollapseCreate(false);
    //  setCollapseOther(value === collapseOther ? '' : value);
  };


  // Define the handleCollapseStatistics function to toggle the collapseStatistics state
  const handleCollapseStatistics = () => {
    setCollapseStatistics(!collapseStatistics);
  };

  useEffect(() => {
    if (orders) {
      setOrdersCount(orders.length);
    }
  }, [orders]);


  const toggleDomainCollapse1 = (domainIndex) => {
    setDomainCollapseState((prevState) => {
      const newState = { ...prevState };
      newState[domainIndex] = !prevState[domainIndex];

      return newState;
    });


  };
  const checkResize = useCallback(async () => {
    if (window.innerWidth === innerWidth.current) {
      return;
    }

    innerWidth.current = window.innerWidth;

    // Update the threshold value to include 'laptop view'
    if (window.innerWidth < 2000) {
      setMode("over"); // Sets the sidebar to overlay mode on smaller screens
      setBasicOpen(false); // Closes the sidebar
      setBackdrop(true); // Shows backdrop
    } else {
      setMode("push"); // Sets the sidebar to the side on larger screens
      setBasicOpen(false); // Opens the sidebar by default on larger screens
      setBackdrop(false); // Hides backdrop
    }
  }, [setBasicOpen, setBackdrop, setMode]);


  const handleBasicCollapse1 = () => {
    setBasicCollapse1(!basicCollapse1);
    
  };


  const handleCollapseApps = () => {
    setCollapseApps(!collapseApps);
    
  };

  
  const handleCollapseDocuments = () => {
    setDummy(true)
    setCollapseDocuments(!collapseDocuments);


    setCollapseInvoices(false);
    setCollapseBills(false);
toggleCollapsePictures(collapsePictures ? '' : 'Pictures') 
toggleCollapsePictures(collapseOther ? '' : 'Other') 
    toggleCollapseReceipts(collapseReceipts ? '' : 'Receipts');
    toggleCollapseOther(collapseTitles ? '' : 'Titles');

  };

  const handleCollapseRm = () => {
    setDummy(true)
    setCollapseRm(!collapseRm);

  };



  const toggleCompany = () => {
    // Toggle the state for the Company collapse.
    setCompCollapse1(prevState => !prevState);

    // When the Company is collapsed, also collapse all inner items.
    if (compCollapse1) {
      const newDomainCollapseState = { ...domainCollapseState };
      Object.keys(newDomainCollapseState).forEach(key => {
        newDomainCollapseState[key] = false;
      });
      setDomainCollapseState(newDomainCollapseState);
    }
  };




  useEffect(() => {
    window.addEventListener('resize', checkResize);

    return () => {
      window.removeEventListener('resize', checkResize);
    };
  }, [checkResize,setBasicOpen]);

  useEffect(() => {
    const fetchData = async () => {
      if (tokenLoaded && !isDocumentsFetched) { // Assume isDocumentsFetched tracks if fetching is needed
        await fetchDocumentMap(setDocumentsMap,tokenLoaded);
        setIsDocumentsFetched(true); // State to prevent re-fetching
      }
    };
  
    fetchData();
  }, [tokenLoaded]); // Only re-run when tokenLoaded changes
  

  useEffect(() => {
    const fetchData = async () => {
      if (tokenLoaded) { // Assume isDocumentsFetched tracks if fetching is needed
        await fetchCompanyMap(setCompaniesMap,tokenLoaded);
        setIsCompaniesFetched(true); // State to prevent re-fetching
        setReceipts(companiesMap?.receipts);
      }
    };
    if (!didFetchRef.current) {
      didFetchRef.current = true;
   
    fetchData();
    }
  }, [tokenLoaded]); // Only re-run when tokenLoaded changes
  


      // useEffect(() => {  
      //   fetchDocumentMap(setDocumentsMap,tokenLoaded);       
      //   }, [documentsMap.length,tokenLoaded]); // Add setDocumentsMap and setCompaniesMap as dependencies
  
      //   useEffect(() => {  
      //     fetchCompanyMap(setCompaniesMap,tokenLoaded);         
      //     }, [companiesMap.length,tokenLoaded]); // Add setDocumentsMap and setCompaniesMap as dependencies
    
  

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const [isDocumentsExpanded, setIsDocumentsExpanded] = useState(false);

  // Function to toggle documents expansion
  const toggleDocumentsExpansion = () => {
    setIsDocumentsExpanded(!isDocumentsExpanded);
  };

  const calculateExpandedHeight = (collapseReceipts, collapseCreate, collapseProcessed, collapseUnprocessed) => {
    let height = 0;
    if (collapseReceipts) {
      height += 400; // Adjust this value according to your layout
      if (collapseCreate === 'Create') {
        height += 400; // Adjust this value according to your layout
      }
      if (collapseProcessed === 'Processed') {
        height += 400; // Adjust this value according to your layout
      }
      if (collapseUnprocessed === 'UnProcessed') {
        height += 400; // Adjust this value according to your layout
      }
    }
    return height;
  };





  // Calculate the height of the expanded child items
  const expandedHeight = calculateExpandedHeight(collapseReceipts, collapseCreate, collapseProcessed, collapseUnprocessed);



  const hasOnlyPricingCategory = selectCategories.length === 1 && selectCategories[0].text === 'pricing';

  return (

//     <MDBSideNav
//       mode={mode}
//       absolute
//       uncontrolled={false}
//       open={basicOpen}
//       isOpen={setBasicOpen}
//       contentRef={containerRef}
//       getOpenState={(e) => setBasicOpen(e)}
//       className="text-primary"
//     >
 <MDBSideNav open={basicOpen}   getOpenState={(e) => setBasicOpen(e)}>

      <MDBRow className='justify-content-center flex-nowrap '>
        <MDBInputGroup className=' justify-content-center flex-nowrap'>
          <MDBCol md="4" className="align-items-center justify-content-center" >
            <MDBRipple tag="a" className="d-flex justify-content-center py-2">
              <img src={localStorage.getItem('LOGO')} alt="Logo" style={{ height: '70px', marginRight: "15px" }} />
            </MDBRipple>
          </MDBCol>
          {tokenLoaded ? <MDBRow className="align-items-center ms-0">

            <MDBCol md="3" className="align-items-center me-1">
              <img
                src={avatar || <MDBIcon fas icon="sign-out-alt" style={{ color: '#c61118' }} />}
                className="rounded"
                style={{ height: 35 }}
                alt=""
              />
            </MDBCol><MDBCol md="5">

              <ClearDataButton isSideNav={true} />
            </MDBCol> </MDBRow> :
            <MDBRow className="align-items-center ms-5">
              <MDBBtn style={{ marginLeft: '20px' }} color="none" onClick={() => setIsLoginRequired(true)} floating href='#'>

                <MDBIcon size='2x' far icon="user" style={{ color: '#c61118' }} />
              </MDBBtn> </MDBRow>}

        </MDBInputGroup>
      </MDBRow>


      <MDBSideNavMenu className=" ms-0">
     <MDBSideNavItem onClick={() => setCompCollapse1(false)}>

          <MDBSideNavLink to={`/home`} tag={Link}>
            <img src='https://opengrit.com/images/home' alt="present" style={{ height: '30px' }} className=" me-3" />Home
          </MDBSideNavLink>
        </MDBSideNavItem>
        

        { business === 'B2C' && cartCount > 0 &&
        // && permissions?.sideNav?.main?.includes("cart") && 
         <MDBSideNavItem className="mb-2">
          <MDBSideNavLink to={`/cart`} tag={Link}>
            <img src='https://opengrit.com/images/shoppingCartFunctionalityIcon' alt="Cart" style={{ height: '40px' }} className="rounded me-2" />
            <MDBBadge color='danger' notification pill>
              {cartCount}
            </MDBBadge> Cart
          </MDBSideNavLink>
        </MDBSideNavItem>
}
        {/* {tokenLoaded && permissions?.sideNav?.main?.includes("orders") &&  */}
        {(ordersCount > 0 || (tokenLoaded && permissions?.sideNav?.main?.includes("orders") ))&&
        <MDBSideNavItem >
          <MDBSideNavLink to={`/order-view`} tag={Link}>
            <img src='https://opengrit.com/images/orderview1' alt="orderview" style={{ height: '35px' }} className="rounded me-2 ms-1" />

            <MDBBadge color='danger' notification pill>
              {ordersCount}
            </MDBBadge>Orders
          </MDBSideNavLink>
        </MDBSideNavItem>
        }



<MDBSideNavItem onClick={() => setCompCollapse1(false)} >
  {tokenLoaded && !hasOnlyPricingCategory &&  permissions?.sideNav?.main?.includes("shop") &&(
    <>
      <MDBSideNavLink to={isPricing ? '/shop/pricing' : '/products'} tag={Link} onClick={handleBasicCollapse1}>
        <img src='https://opengrit.com/images/effortlessSales1' alt="Shop" style={{ height: '40px' }} className="rounded me-2" />Shop
      </MDBSideNavLink>
      {selectCategories?.map((category, index) => (
        <MDBSideNavCollapse open={basicCollapse1} key={index}>
          <MDBSideNavLink key={index} to={`/shop/${category.text}`} tag={Link}>
            {category.text}
          </MDBSideNavLink>
        </MDBSideNavCollapse>
      ))}
    </>
  )}
</MDBSideNavItem>

        {/* {business === 'B2C' && selectCategories?.length > 0 && permissions?.sideNav?.main?.includes("shop") && */}
          {/* <MDBSideNavItem onClick={() => setCompCollapse1(false)} >
            <MDBSideNavLink to={isPricing ? '/shop/pricing' : '/products'} tag={Link} onClick={handleBasicCollapse1}>
              <img src='https://opengrit.com/images/effortlessSales1' alt="Shop" style={{ height: '40px' }} className="rounded me-2" />Shop
            </MDBSideNavLink>
            {selectCategories?.map((category, index) => (
              <MDBSideNavCollapse open={basicCollapse1} key={index}>
                <MDBSideNavLink key={index} to={`/shop/${category.text}`} tag={Link}>
                  {category.text}
                </MDBSideNavLink>
              </MDBSideNavCollapse>
            ))}
          </MDBSideNavItem> */}
        {tokenLoaded &&
          <>
            {permissions?.sideNav?.main?.includes("documents") &&
              <MDBSideNavItem onClick={() => { setCompCollapse1(false); setBasicCollapse1(false); setCollapseStatistics(false); }} className="mt-2">

                <MDBSideNavLink onClick={() => { handleCollapseDocuments(); toggleDocumentsExpansion(); toggleCollapseReceipts('Receipts'); toggleCollapseReceipts('Others') }} icon='angle-down'>
                  <img src='https://opengrit.com/images/iconReceipt' alt="iconReceipt" style={{ height: '30px' }} className="me-3" /> Documents
                </MDBSideNavLink>
                <MDBSideNavCollapse open={collapseDocuments}>


                  <MDBSideNavItem >

                    <MDBSideNavLink to={`/view/type/receipt`} className="ms-4"
                      shouldBeExpanded={collapseReceipts === 'Receipts'}
                      onClick={() => { toggleCollapseReceipts('Receipts'); setDummy(dummy ? !dummy : dummy)}}
                    >
                      <MDBTypography className='text-black'>
                        Receipts
                      </MDBTypography>
                    </MDBSideNavLink>

                    <MDBSideNavCollapse open={collapseReceipts} className="ms-4">
                      <MDBSideNavItem className="ms-4" >
                        <MDBSideNavLink to={`/no-receipts/receipt`} tag={Link} shouldBeExpanded={collapseCreate === 'Create'} onClick={() => toggleCollapseCreate('Create')}>
                          <MDBTypography tag='strong' className='link-success'>
                            Create
                          </MDBTypography>
                        </MDBSideNavLink>
                      </MDBSideNavItem>

                      <MDBSideNavItem className="ms-4">
                        <MDBSideNavLink to={`/processed/receipt`} tag={Link} shouldBeExpanded={collapseProcessed === 'Processed'} onClick={() => toggleCollapseProcessed('Processed')}>
                          <MDBTypography tag='strong' className='link-success'>
                            Processed
                          </MDBTypography>
                        </MDBSideNavLink>
                      </MDBSideNavItem>
                      <MDBSideNavItem className="ms-4">
                        <MDBSideNavLink to={`/unProcessed/receipt`} tag={Link} shouldBeExpanded={collapseUnprocessed === 'UnProcessed'} onClick={() => toggleCollapseUnProcessed('UnProcessed')}>
                          <MDBTypography tag='strong' className='link-success'>
                            UnProcessed
                          </MDBTypography>
                        </MDBSideNavLink>


                      </MDBSideNavItem>


                    </MDBSideNavCollapse>
                  </MDBSideNavItem>

                  <MDBSideNavItem >

<MDBSideNavLink to={`/view/type/picture`} className="ms-4"
  shouldBeExpanded={collapsePictures === 'Pictures'}
  onClick={() => { toggleCollapseReceipts('Receipts'); setDummy(dummy ? !dummy : dummy)}}
>
  <MDBTypography className='text-black'>
    Pictures
  </MDBTypography>
</MDBSideNavLink>

<MDBSideNavCollapse open={collapsePictures} className="ms-4">
  <MDBSideNavItem className="ms-4" >
    <MDBSideNavLink to={`/no-receipts/picture`} tag={Link} shouldBeExpanded={collapseCreate === 'Create'} onClick={() => toggleCollapseCreate('Create')}>
      <MDBTypography tag='strong' className='link-success'>
        Create
      </MDBTypography>
    </MDBSideNavLink>
  </MDBSideNavItem>

  <MDBSideNavItem className="ms-4">
    <MDBSideNavLink to={`/processed/picture`} tag={Link} shouldBeExpanded={collapseProcessed === 'Processed'} onClick={() => toggleCollapseProcessed('Processed')}>
      <MDBTypography tag='strong' className='link-success'>
        Processed
      </MDBTypography>
    </MDBSideNavLink>



  </MDBSideNavItem>


  <MDBSideNavItem className="ms-4">
    <MDBSideNavLink to={`/unProcessed/picture`} tag={Link} shouldBeExpanded={collapseUnprocessed === 'UnProcessed'} onClick={() => toggleCollapseUnProcessed('UnProcessed')}>
      <MDBTypography tag='strong' className='link-success'>
        UnProcessed
      </MDBTypography>
    </MDBSideNavLink>


  </MDBSideNavItem>


</MDBSideNavCollapse>
</MDBSideNavItem>



                  <MDBSideNavItem >

                    <MDBSideNavLink to={`/view/type/title`} className="ms-4"
                      shouldBeExpanded={collapseTitles === 'Titles'}
                      onClick={() => { toggleCollapseTitles('Titles'); setDummy(dummy ? !dummy : dummy)}}
                    >
                      <MDBTypography className='text-black'>
                        Titles
                      </MDBTypography>
                    </MDBSideNavLink>

                    <MDBSideNavCollapse open={collapseTitles} className="ms-4">
                      <MDBSideNavItem className="ms-4" >
                        <MDBSideNavLink to={`/no-receipts/title`} tag={Link} shouldBeExpanded={collapseCreate === 'Create'} onClick={() => toggleCollapseCreate('Create')}>
                          <MDBTypography tag='strong' className='link-success'>
                            Create
                          </MDBTypography>
                        </MDBSideNavLink>
                      </MDBSideNavItem>

                      <MDBSideNavItem className="ms-4">
                        <MDBSideNavLink to={`/processed/title`} tag={Link} shouldBeExpanded={collapseProcessed === 'Processed'} onClick={() => toggleCollapseProcessed('Processed')}>
                          <MDBTypography tag='strong' className='link-success'>
                            Processed
                          </MDBTypography>
                        </MDBSideNavLink>



                      </MDBSideNavItem>


                      <MDBSideNavItem className="ms-4">
                        <MDBSideNavLink to={`/unProcessed/title`} tag={Link} shouldBeExpanded={collapseUnprocessed === 'UnProcessed'} onClick={() => toggleCollapseUnProcessed('UnProcessed')}>
                          <MDBTypography tag='strong' className='link-success'>
                            UnProcessed
                          </MDBTypography>
                        </MDBSideNavLink>


                      </MDBSideNavItem>


                    </MDBSideNavCollapse>
                  </MDBSideNavItem>

                  <MDBSideNavItem className="ms-4" >
                    {/* <MDBSideNavLink to={`/view/type/other`} shouldBeExpanded={collapseOther === 'Other'} tag={Link} onClick={() => toggleCollapseOther('Other')}> */}
                    <MDBSideNavLink shouldBeExpanded={collapseOther === 'Other'} tag={Link} onClick={() => { toggleCollapseOther('Other'); setDummy(dummy ? !dummy : dummy) }}>
                      <MDBTypography className='text-black'>
                        Other
                      </MDBTypography>
                    </MDBSideNavLink>
                    <MDBSideNavCollapse open={collapseOther}>
                      <MDBSideNavItem className="ms-2" >
                        <MDBSideNavLink to={`/no-receipts/other`} tag={Link} shouldBeExpanded={collapseCreate === 'Create'} onClick={() => toggleCollapseCreate('Create')}>
                          <MDBTypography tag='strong' className='link-success'>
                            Create
                          </MDBTypography>
                        </MDBSideNavLink>
                      </MDBSideNavItem>
                      <MDBSideNavItem className="ms-2">
                        <MDBSideNavLink to={`/processed/other`} tag={Link} shouldBeExpanded={collapseProcessed === 'Processed'} onClick={() => toggleCollapseProcessed('Processed')}>
                          <MDBTypography tag='strong' className='link-success'>
                            Processed
                          </MDBTypography>
                        </MDBSideNavLink>

                      </MDBSideNavItem>
                      <MDBSideNavItem className="ms-2">
                        <MDBSideNavLink to={`/unProcessed/other`} tag={Link} shouldBeExpanded={collapseUnprocessed === 'UnProcessed'} onClick={() => toggleCollapseUnProcessed('UnProcessed')}>
                          <MDBTypography tag='strong' className='link-success'>
                            UnProcessed
                          </MDBTypography>
                        </MDBSideNavLink>

                      </MDBSideNavItem>

                    </MDBSideNavCollapse>
                  </MDBSideNavItem>
                  <MDBSideNavCollapse open={dummy}>
                    <MDBSideNavItem>
                      <MDBSideNavLink shouldBeExpanded={dummy}> </MDBSideNavLink>
                    </MDBSideNavItem>
                    <MDBSideNavItem>
                      <MDBSideNavLink shouldBeExpanded={dummy}> </MDBSideNavLink>
                    </MDBSideNavItem>
                    <MDBSideNavItem>
                      <MDBSideNavLink shouldBeExpanded={dummy}> </MDBSideNavLink>
                    </MDBSideNavItem>
                  </MDBSideNavCollapse>
                </MDBSideNavCollapse>




              </MDBSideNavItem>

            }




            {permissions?.sideNav?.main?.includes("inventory") && <MDBSideNavItem id="inventory-item" onClick={() => { setCompCollapse1(false); setCollapseDocuments(false); setCollapseStatistics(false) }} className="mt-2" style={{ marginTop: expandedHeight }} >
              <MDBSideNavLink to={`/domain/entities`} tag={Link}>
                <img src='https://opengrit.com/images/inventory' alt="Inventory" style={{ height: '30px' }} className=" me-4" />Inventory
              </MDBSideNavLink>
            </MDBSideNavItem>
            }


            {permissions?.sideNav?.main?.includes("analytics") && <MDBSideNavItem onClick={() => { setCompCollapse1(false); setBasicCollapse1(false); setCollapseDocuments(false) }} className="mt-2">
              <MDBSideNavLink to={`/dashboard`} onClick={() => { handleCollapseStatistics() }} tag={Link}>
                <img src='https://opengrit.com/images/stats' alt="stats" style={{ height: '30px' }} className="me-3" />Analytics
              </MDBSideNavLink>
              <MDBSideNavCollapse open={collapseStatistics}>
                <MDBSideNavLink to={`/report`} tag={Link}>
                  Report
                </MDBSideNavLink>
              </MDBSideNavCollapse>
            </MDBSideNavItem>}

            {permissions?.sideNav?.main?.includes("requests") && <MDBSideNavItem onClick={() => { setCompCollapse1(false); setCollapseDocuments(false); setCollapseStatistics(false) }} className="mt-2">
              <MDBSideNavLink icon="angle-down" onClick={() => { handleCollapseStatistics(); handleBasicCollapse1() }} tag={Link}>
                <img src='https://opengrit.com/images/request' alt="requests" style={{ height: '30px' }} className="me-4" />Requests
              </MDBSideNavLink>
              <MDBSideNavCollapse open={basicCollapse1}>

                <MDBSideNavLink to={`/RequestView`} tag={Link}>
                  View
                </MDBSideNavLink>


                <MDBSideNavLink tag={Link} to={`/createRequest`}>
                  Create
                </MDBSideNavLink>

              </MDBSideNavCollapse>
            </MDBSideNavItem>
            }
          </>}

        {tokenLoaded && permissions?.sideNav?.main?.includes("userProfile") && (<MDBSideNavItem onClick={() => { setCompCollapse1(false); setBasicCollapse1(false); setDomainCollapseState(false) }} className="mt-2">
          <MDBSideNavLink to={`/user-profile`} tag={Link}>
            <img src='https://opengrit.com/images/userprofile' alt="userProfile" style={{ height: '30px' }} className="me-3" />User Profile
          </MDBSideNavLink>
        </MDBSideNavItem>)}

        {
          tokenLoaded && localStorage.getItem('ROLE') === 'admin'  && permissions?.sideNav?.main?.includes("contacts") && (


            <MDBSideNavLink to={`/contactsview`} tag={Link}>
              <MDBIcon fas icon="users" className="fa-fw me-3 ms-2 mt-3 mb-3" />
              Contacts
            </MDBSideNavLink>
          )}

        {tokenLoaded && localStorage.getItem('ROLE') === 'admin' && permissions?.sideNav?.main?.includes("marketing") && (

          <MDBSideNavItem className="mb-2 mt-2" onClick={() => { setCompCollapse1(false); setBasicCollapse1(false); setDomainCollapseState(false) }}>
            <MDBSideNavLink to={`/marketing`} tag={Link}>
              <img src='https://opengrit.com/images/marketing' alt="marketing" style={{ height: '30px' }} className="me-3" />Marketing
            </MDBSideNavLink>
          </MDBSideNavItem>)

        }
        { tokenLoaded && localStorage.getItem('ROLE') === 'admin' && permissions?.sideNav?.main?.includes("company") && (
            <MDBSideNavItem className="mb-2 mt-2">
              <MDBSideNavLink icon="angle-down" onClick={() => {
                toggleCompany();
                //fetchIPAddress( setIPAddress); 

                if (!ipAddress) {
                  // Call fetchIPAddress only if ipAddress is not defined or empty
                  fetchIPAddress(setIPAddress);
                }
                getDomainsAndCategories( firmId, location, ipAddress, tokenLoaded, setBusiness, setCountry, setSelectCategories, setSelectDomains, setGroupedCategoriesByDomain, setCategoryImages, setGroupedDomainsByDomain, setDomainImages,setDomainId,setFirmId);
              // if (selectDomains?.length === 0) {
              //     getDomainsAndCategories(domainId, location, ipAddress, tokenLoaded, setBusiness, setCountry, setSelectCategories, setSelectDomains, setGroupedCategoriesByDomain, setCategoryImages, setGroupedDomainsByDomain, setDomainImages,setDomainId,setFirmId);
              // }
                 }}>
                <img src='https://opengrit.com/images/company' alt="company2" style={{ height: '30px' }} className="me-3" />AdminTasks
              </MDBSideNavLink>
              <MDBSideNavCollapse open={compCollapse1}>
  {localStorage.getItem('ROLE') === 'admin' && (
    selectDomains?.map((domain, domainIndex) => (
      <MDBSideNavItem key={domain.value} className="mb-2 mt-2">
        <MDBSideNavLink
          to={`/domain/${domain.value}`}
          onClick={() => toggleDomainCollapse(domainIndex)}
          tag={Link}
        >
          <img
            src="https://opengrit.com/images/companySub"
            alt="company1"
            style={{ height: '25px' }}
          />
          <span className="ms-1">{domain.text}</span>
        </MDBSideNavLink>
        <MDBSideNavCollapse open={openDomainIndex === domainIndex}>
          {domainData && (
            <MDBSideNavItem className="ms-4">
              <MDBSideNavLink to={`/category/${domain.value}`} tag={Link}>
                Categories
              </MDBSideNavLink>
            </MDBSideNavItem>
          )}
          {domainData && (
            <MDBSideNavItem className="ms-4">
              <MDBSideNavLink to={`/domain/${domain.value}/entities`} tag={Link}>
                Entities
              </MDBSideNavLink>
            </MDBSideNavItem>
          )}
          {domainData && permissions?.sideNav?.company?.includes('users') && (
            <>
              <MDBSideNavItem className="ms-4">
                <MDBSideNavLink to={`/domain/${domain.value}/users`} tag={Link}>
                  Users
                </MDBSideNavLink>
              </MDBSideNavItem>
              <MDBSideNavItem className="ms-4">
                <MDBSideNavLink to={`/domain/${domain.value}/groups`} tag={Link}>
                  Groups
                </MDBSideNavLink>
              </MDBSideNavItem>
            </>
          )}
          {domainData && (
            <MDBSideNavItem className="ms-4">
              <MDBSideNavLink to={`/addresses/${domain.value}`} tag={Link}>
                Addresses
              </MDBSideNavLink>
            </MDBSideNavItem>
          )}
          {domainData && permissions?.sideNav?.company?.includes('users') && (
            <MDBSideNavItem className="ms-4">
              <MDBSideNavLink to={`/classroomSetup`} tag={Link}>
                ClassroomSetup
              </MDBSideNavLink>
            </MDBSideNavItem>
          )}
        </MDBSideNavCollapse>
      </MDBSideNavItem>
    ))
  )}
</MDBSideNavCollapse>





              {/* <MDBSideNavCollapse open={compCollapse1} >
                {localStorage.getItem('ROLE') === 'admin' && (

                  selectDomains?.map((domain, domainIndex) => (
                    <MDBSideNavItem key={domain.value} className="mb-2 mt-2">
                      <MDBSideNavLink to={`/domain/${domain.value}`} onClick={() => toggleDomainCollapse(domainIndex)} tag={Link}>
                        <img src='https://opengrit.com/images/companySub' alt="company1" style={{ height: '25px' }} />
                        <span className="ms-1">{domain.text}</span>
                      </MDBSideNavLink>
                      <MDBSideNavCollapse open={domainCollapseState[domainIndex]}>
                        {
                          domainData && (
                            <MDBSideNavItem className="ms-4">

                              <MDBSideNavLink to={`/category/${domain.value}`} tag={Link}>
                                Categories
                              </MDBSideNavLink>

                            </MDBSideNavItem>
                          )
                        }
                        {
                          domainData && (
                            <MDBSideNavItem className="ms-4">

                              <MDBSideNavLink to={`/domain/${domain.value}/entities`} tag={Link}>
                                Entities
                              </MDBSideNavLink>

                            </MDBSideNavItem>

                          )

                        }


                        {
                          domainData && permissions?.sideNav?.company?.includes('users') && (
                            <MDBSideNavItem className="ms-4">


                              <MDBSideNavLink to={`/domain/${domain.value}/users`} tag={Link}>
                                Users
                              </MDBSideNavLink>

                            </MDBSideNavItem>

                          )

                        }

{
                          domainData && permissions?.sideNav?.company?.includes('users') && (
                            <MDBSideNavItem className="ms-4">


                              <MDBSideNavLink to={`/domain/${domain.value}/groups`} tag={Link}>
                                Groups
                              </MDBSideNavLink>

                            </MDBSideNavItem>

                          )

                        }

                        {
                          domainData && (
                            <MDBSideNavItem className="ms-4">

                              <MDBSideNavLink to={`/addresses/${domain.value}`} tag={Link} >
                                Addresses
                              </MDBSideNavLink>

                            </MDBSideNavItem>

                          )

                        }



{
                          domainData && permissions?.sideNav?.company?.includes('users') && (
                            <MDBSideNavItem className="ms-4">


                              <MDBSideNavLink to={`/classroomSetup`} tag={Link}>
                              ClassroomSetup
                              </MDBSideNavLink>

                            </MDBSideNavItem>

                          )

                        }

                      </MDBSideNavCollapse>
                    </MDBSideNavItem>
                  ))
                )}
              </MDBSideNavCollapse> */}

            </MDBSideNavItem>



          )
        }
        

        {tokenLoaded && <MDBSideNavItem onClick={() => setCompCollapse1(false)} className="mt-2">

<MDBSideNavLink to={`qrCodes`} tag={Link}>
  <img src='https://opengrit.com/images/presentationIcon' alt="present" style={{ height: '40px' }} className="me-2" />QrCodes
</MDBSideNavLink>
</MDBSideNavItem>}

        {permissions?.sideNav?.main?.includes("presentation") && <MDBSideNavItem onClick={() => setCompCollapse1(false)} className="mt-2">

          <MDBSideNavLink to={`/companyCreation`} tag={Link}>
            <img src='https://opengrit.com/images/presentationIcon' alt="present" style={{ height: '40px' }} className="me-2" />Presentation
          </MDBSideNavLink>
        </MDBSideNavItem>}
        {permissions?.sideNav?.main?.includes("idCards") &&
          <MDBSideNavItem onClick={() => setCompCollapse1(false)}>

            <MDBSideNavLink to={`/idCards`} tag={Link}>
              <img src='https://opengrit.com/images/idCard' alt="Card" style={{ height: '20px', width: '25px' }} className="me-4" />IdCards
            </MDBSideNavLink>
          </MDBSideNavItem>}
        <MDBSideNavItem onClick={() => { setCompCollapse1(false); setBasicCollapse1(false); setCollapseStatistics(false); }} className="mt-2">
        <MDBSideNavItem onClick={() => setCompCollapse1(false)}>

<MDBSideNavLink to={`/demo/builder`} tag={Link}>
  <img src='https://opengrit.com/images/demobuilder' alt="present" style={{ height: '30px' }} className=" me-3" />DemoBuilder
</MDBSideNavLink>
<MDBSideNavLink to={`/sales/questionanswer/form`} tag={Link}>
<img src='https://opengrit.com/images/qtnans' alt="present" style={{ height: '30px' }} className=" me-3" />SaleQuestions
 </MDBSideNavLink>
 {(domainId ==='6679109d5fe12f31b92514eb' || host==='opengrit.com') &&<>
  <MDBSideNavItem onClick={() => setCompCollapse1(false)}>

<MDBSideNavLink to={`/paystub`} tag={Link}>
  <img src='https://opengrit.com/images/home' alt="present" style={{ height: '30px' }} className=" me-3" />PayStub
</MDBSideNavLink>
</MDBSideNavItem>
              <MDBSideNavLink to={`/javen-mobile`} tag={Link}>
                <MDBIcon fas icon="pen-nib" className="fa-fw me-3" />
               javen-mobile
              </MDBSideNavLink>


              
         
            
              <MDBSideNavLink to={`/javen-desktop`} tag={Link}>
                <MDBIcon fas icon="pen-nib" className="fa-fw me-3" />
               javen-desktop
              </MDBSideNavLink></>
            }
          
</MDBSideNavItem>

{domainId ==='6679109d5fe12f31b92514eb' &&
<MDBSideNavLink onClick={() => { handleCollapseRm()}} icon='angle-down'>
  <img src='https://opengrit.com/images/roadMap' alt="iconRm" style={{ height: '30px' }} className="me-3" /> RoadMap
</MDBSideNavLink>}
<MDBSideNavCollapse open={collapseRm}>
            <MDBSideNavItem>
            <MDBSideNavLink to={`/org`} tag={Link}>
                <MDBIcon fas icon="chart-area" className="fa-fw me-3" />
                Organization
              </MDBSideNavLink>
              </MDBSideNavItem>
            <MDBSideNavItem>
              <MDBSideNavLink to={`/seo`} tag={Link}>
                <MDBIcon fas icon="chart-area" className="fa-fw me-3" />
                SEO dashboard
              </MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem>
              <MDBSideNavLink to={`/e-commerce1`} tag={Link} >
                <MDBIcon fas icon="chart-pie" className="fa-fw me-3" />
                eCommerce dashboard
              </MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem>
              <MDBSideNavLink to={`/e-commerce2`} tag={Link}>
                <MDBIcon fas icon="chart-line" className="fa-fw me-3" />
                eCommerce dashboard
              </MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem>
              <MDBSideNavLink to={`/ads-dashboard`} tag={Link}>
                <MDBIcon fas icon="chart-pie" className="fa-fw me-3" />
                Ads dashboard
              </MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem>
              <MDBSideNavLink to={'/order-dashboard'} tag={Link}>
                <MDBIcon fas icon="chart-bar" className="fa-fw me-3" />
                Order dashboard
              </MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem>
              <MDBSideNavLink to={`/traffic-dashboard`} tag={Link}>
                <MDBIcon fas icon="chart-area" className="fa-fw me-3" />
                Traffic dashboard
              </MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem>
              <MDBSideNavLink to={`/invoice-page`} tag={Link}>
                <MDBIcon fas icon="money-bill" className="fa-fw me-3" />
                Invoice page
              </MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem>            
                <MDBSideNavLink  tag={Link} onClick={handleCollapseApps}>
                <MDBIcon fas icon="tablet-alt" className="fa-fw me-3" />
                Apps
              </MDBSideNavLink>
              <MDBSideNavCollapse open={collapseApps}>
                <MDBSideNavLink to={`/chat-app`} tag={Link}>
                  Chat app
                </MDBSideNavLink>
                <MDBSideNavLink to={`/mailbox-app`} tag={Link}>
                  Mailbox app
                </MDBSideNavLink>
              </MDBSideNavCollapse>
            </MDBSideNavItem>
            </MDBSideNavCollapse>
                       </MDBSideNavItem> 
          







      </MDBSideNavMenu>
    </MDBSideNav>

  );
}
Sidenav.propTypes = {
  containerRef: PropTypes.object
};